import { Dialog, DialogContent } from '@/components/ui/dialog';
import type { SimplifiedCorrespondenceChatProps } from '../index';
import { ChatContainerSimplified } from '../index';

interface FullscreenDialogProps extends Omit<
  SimplifiedCorrespondenceChatProps,
  'isInFullScreenDialog'
> {
  isOpen: boolean;
  onClose: () => void;
}

export function FullscreenDialog({
  isOpen,
  onClose,
  ...chatProps
}: FullscreenDialogProps) {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent
        className="flex h-[90vh] w-[90vw] max-w-5xl flex-col p-0"
        hideCloseButton
      >
        <div className="flex-1 overflow-hidden">
          <ChatContainerSimplified
            {...chatProps}
            fullHeight={true}
            isInFullScreenDialog={true}
            onCloseFullScreen={onClose}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}
